import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import Catalog from "./components/Catalog";
import Collections from "./components/Collections";
import Archives from "./components/Archives";
import Timeline from "./components/Timeline";
import Specials from "./components/Specials";
import OldNews from "./components/OldNews";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main id="top" className="bg-cream text-ink">
      <Navbar />
      <Hero />
      <Trending />
      <Catalog />
      <Collections />
      <Archives />
      <Timeline />
      <Specials />
      <OldNews />
      <Faq />
      <Footer />
    </main>
  );
}